import { LazyMotion, domAnimation, m, useIsPresent } from "framer-motion";
import React, { ReactNode } from "react";

export type TFadeAndCollapseOnExit = {
    children: ReactNode;
    fadeDuration?: number;
    collapseDuration?: number;
};

export const FadeAndCollapseOnExit = ({
    children,
    fadeDuration = 0.5,
    collapseDuration = 0.5,
}: TFadeAndCollapseOnExit) => {
    const isPresent = useIsPresent();

    const variants = {
        expanded: { opacity: 1 },
        collapsed: {
            opacity: 0,
            height: 0,
            transition: {
                ease: "easeInOut",
                opacity: { duration: fadeDuration },
                height: { delay: fadeDuration, duration: collapseDuration },
            },
        },
    };

    return (
        <LazyMotion features={domAnimation}>
            <m.div
                initial="expanded"
                animate="expanded"
                exit="collapsed"
                variants={variants}
                style={!isPresent ? { overflow: "hidden" } : {}}
            >
                {children}
            </m.div>
        </LazyMotion>
    );
};
